<template>
  <div class="attr" @mouseover="isExpanded = true" @mouseleave="isExpanded = false">
    <span v-if="!isAttributeExpandable">{{ value }}</span>

    <span v-if="isAttributeExpandable" class="shortendAttr">{{ shortendAttr }}...</span>

    <span v-if="isAttributeExpandable && isExpanded" class="fullAttr">{{ value }}</span>
  </div>
</template>

<script lang="ts">
const CHARACTER_LIMIT = 15;

export default defineComponent({
  name: 'VariantsAttribute',
});
</script>

<script setup lang="ts">
type Props = {
  value?: string;
  characterLimit?: number;
};

const props = withDefaults(defineProps<Props>(), {
  value: '',
  characterLimit: CHARACTER_LIMIT,
});

const isExpanded = ref(false);

const isAttributeExpandable = computed(() => props.value.length > props.characterLimit);
const shortendAttr = computed(() => props.value.slice(0, props.characterLimit));
</script>

<style lang="scss" scoped>
.attr {
  position: relative;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.shortendAttr {
  cursor: pointer;
}

.fullAttr {
  position: absolute;
  top: -5px;
  left: 0;
  z-index: 1;
  cursor: pointer;
  @apply p-3 bg-white;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.06);
  border-radius: 4px;
}
</style>
